@keyframes store-marker-pulse {
  0% {
    box-shadow: 0 0 0 0 var(--marker-color-faded);
  }

  70% {
    box-shadow: 0 0 0 6px var(--marker-color-transparent);
  }

  100% {
    box-shadow: 0 0 0 0 var(--marker-color-transparent);
  }
}

.store-marker {
  cursor: pointer;
}

.store-marker-popup .mapboxgl-popup-content {
  padding: 12px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.store-marker-popup.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip {
  border-top-color: white;
}

.store-marker-popup.mapboxgl-popup-anchor-top .mapboxgl-popup-tip {
  border-bottom-color: white;
}

.store-marker-popup.mapboxgl-popup-anchor-left .mapboxgl-popup-tip {
  border-right-color: white;
}

.store-marker-popup.mapboxgl-popup-anchor-right .mapboxgl-popup-tip {
  border-left-color: white;
}

.store-marker-popup.mapboxgl-popup-anchor-bottom-left .mapboxgl-popup-tip,
.store-marker-popup.mapboxgl-popup-anchor-bottom-right .mapboxgl-popup-tip {
  border-top-color: white;
}

.store-marker-popup.mapboxgl-popup-anchor-top-left .mapboxgl-popup-tip,
.store-marker-popup.mapboxgl-popup-anchor-top-right .mapboxgl-popup-tip {
  border-bottom-color: white;
}